module.exports = __webpack_public_path__ + "img/box3_img1_light.7cacec15.png";